module.exports = __webpack_public_path__ + "static/media/SammyMoxie-thumb.4255f76a.jpg";